/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Center } from './Center';
import {
    CenterFromJSON,
    CenterFromJSONTyped,
    CenterToJSON,
    CenterToJSONTyped,
} from './Center';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseCenter
 */
export interface ResponseCenter {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseCenter
     */
    result: ResponseResult;
    /**
     * 
     * @type {Center}
     * @memberof ResponseCenter
     */
    data: Center;
}

/**
 * Check if a given object implements the ResponseCenter interface.
 */
export function instanceOfResponseCenter(value: object): value is ResponseCenter {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseCenterFromJSON(json: any): ResponseCenter {
    return ResponseCenterFromJSONTyped(json, false);
}

export function ResponseCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCenter {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': CenterFromJSON(json['data']),
    };
}

export function ResponseCenterToJSON(json: any): ResponseCenter {
    return ResponseCenterToJSONTyped(json, false);
}

export function ResponseCenterToJSONTyped(value?: ResponseCenter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': CenterToJSON(value['data']),
    };
}

